import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJcsFormFieldsRoute: InvariantJiraRoute = {
	name: 'products-jcs-form-fields',
	path: '/jira/settings/products/customerservice/form-fields',
	exact: true,
};
